export default __webpack_public_path__ + "static/media/loader.e075e484.svg";